import { PosIconProps, SvgWrapper } from 'src/svgs/SvgWrapper';

export function ArrowUpIcon(props: PosIconProps) {
  return (
    <SvgWrapper viewBox="0 0 16 16" fill="currentColor" {...props}>
      <path d="M3.281 15L0 11.719l8-8 8 8L12.719 15 8 10.281z" />
    </SvgWrapper>
  );
}
